import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/ca", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createCA(request, requestOptions) {
  return __request__("POST", "/ca/create", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function uploadCA(password, files, requestOptions) {
  const formData = new FormData();
  formData.append("password", password);
  files.forEach((f) => formData.append("files", f));
  return __request__("POST", "/ca/upload", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
